// FLAGS: identity, silent-failure
// Builds the long-lived generated-client instances (v1, v2) that carry the session cookie to OpenUp.Api.
import { HttpClient } from "@src/api/v1/http-client";
import { HttpClient as HttpClientV2 } from "@src/api/v2/http-client";
import { getApiBaseUrl } from "@src/utils/urlHelpers";
import qs from "qs";

const config = {
  baseURL: getApiBaseUrl(false),
  withCredentials: true,
  paramsSerializer: (params) => qs.stringify(params, { indices: false }),
};
export const OpenUpHttpClient = new HttpClient(config);
// FLAGS: identity, silent-failure
// Called after AxiosSetup has run, so the instance it returns carries no interceptors: no App Insights record of a
// failure, and a 401 is never refreshed. It also defaults withCredentials to true, sending the session cookie to
// whatever host the caller names.
export const OpenUpHttpClientWithBaseURL = (
  baseURL: string,
  withCredentials: boolean = true,
) =>
  new HttpClient({
    baseURL: baseURL,
    withCredentials,
  });
export const OpenUpHttpClientV2 = new HttpClientV2(config);
